import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsZoomOut = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <g fill="currentColor">
        <path
          d="M17.8032494,17.1782417h0.0000019c1.6950054-1.8563242,2.6255054-4.2480354,2.6255054-6.7543058
			c0-1.3513279-0.2641869-2.6652493-0.7878857-3.9020181c-0.5049953-1.1946874-1.2274189-2.2654629-2.1485672-3.1866097
			c-0.9211483-0.9211485-1.9942608-1.643572-3.1866093-2.1485662c-1.2391071-0.5236988-2.5530291-0.7878855-3.904357-0.7878855
			c-1.3583422,0-2.6746011,0.2641868-3.9113712,0.7878855C5.2952805,1.6917361,4.2245049,2.4141595,3.3033566,3.3353081
			C2.384547,4.2564549,1.6644608,5.3272305,1.1594667,6.5219178c-0.52136,1.2344313-0.7855468,2.5483527-0.7855468,3.8996816
			s0.2641868,2.6652498,0.7855468,3.8996811c0.5026567,1.1946859,1.2250803,2.2678003,2.1438899,3.1866102
			c0.9188094,0.9211483,1.9919238,1.6435699,3.1866097,2.1485653c1.2367702,0.5236988,2.5530291,0.7878857,3.9113712,0.7878857
			c2.4548349,0,4.7997875-0.8884163,6.6280546-2.5015945l5.6905422,5.6905422l0.8019123-0.7668419L17.8032494,17.1782417z
			 M10.3756218,19.3501854c-4.9096708,0-8.9028692-4.0048885-8.9028692-8.9262495
			c0.0023373-4.92136,4.0072255-8.9262486,8.928586-8.9262486s8.9262486,4.0048885,8.9262486,8.9262486
			S15.3110094,19.3501854,10.3756218,19.3501854z"
        />
        <rect
          x="4.8651009"
          y="9.9493351"
          width="11.0490971"
          height="0.9749206"
        />
      </g>
    </SvgIcon>
  );
});

export default AppIconsZoomOut;
